import { useCallback, useState } from 'react'
import styled from 'styled-components'

import { Tabs } from 'components/Tabs/Tabs'
import { Typography } from 'components/Typography/Typography'
import { LpVaultsListContainer } from 'modules/LpVaults/components/LpVaultsListContainer'
import { VaultsListContainer } from 'modules/Vaults/components/VaultsListContainer'
import { Stylable } from 'utils/types'
import { SearchInput } from 'components/SearchInput/SearchInput'

interface Props extends Stylable {}

const VaultsWrapper = styled.div`
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    padding: 0px 20px;
  }
`

const VaultsContainer = styled.div`
  max-width: 1200px;
  margin: auto;
`

const VaultsSearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;

  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    flex-direction: column;
    margin-top: 80px;
    margin-bottom: 0;

    & > div {
      font-size: ${p => p.theme.typography.size.Subtitle2}px;
      margin-bottom: 16px;
    }
  }
`

export const AllVaults = ({ style }: Props) => {
  const [searchText, setSearchText] = useState('')

  const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value)
  }, [])

  const handleClear = useCallback(() => {
    setSearchText('')
  }, [])

  const tabData = [
    {
      label: 'Single Asset Vaults',
      content: <VaultsListContainer isHomePage searchQuery={searchText} />,
    },
    {
      label: 'Liquidity Provider Vaults',
      content: <LpVaultsListContainer isHomePage searchQuery={searchText} />,
    },
  ]

  return (
    <VaultsWrapper style={style}>
      <VaultsContainer>
        <VaultsSearchContainer>
          <Typography variant="title2">
            All <span style={{ fontWeight: 700 }}>Vaults</span>
          </Typography>
          <SearchInput text={searchText} onChange={handleInputChange} onClear={handleClear} />
        </VaultsSearchContainer>
        <Tabs tabs={tabData} />
      </VaultsContainer>
    </VaultsWrapper>
  )
}
